<template>
  <div class="admin-recrtuiter-common-info-scene">
    <template v-if="!loading">
      <div class="recruiter-info-wrapper basic-form">
        <div class="status-row status-row__free">
          <div class="status">
            <div class="checkbox-wrapper">
              <vchecklabel
                v-model="vacancy.is_permanent_response_link"
                :label="$tr('admin_console.vacancy.is_permanent_response_link')"
              />
            </div>
          </div>
        </div>

        <div>
          <vbutton label="settings.managers.editUser.save" @click="update_vacancy" />
        </div>
      </div>
    </template>

    <vpreloader v-else />
  </div>
</template>

<script>
import { STORE_PREFIX } from '../../constants.js';
import { mapGetters } from 'vuex';

export default {
  name: 'AdminVacancyScene',

  props: {
    vacancyId: null
  },

  computed: {
    ...mapGetters(STORE_PREFIX + 'admin', {
      loading: 'vacancy/loading',
      vacancy: 'vacancy/vacancy'
    })
  },

  beforeMount() {
    this.fetch();
  },

  beforeDestroy() {
    this.$store.commit(STORE_PREFIX + 'admin/vacancy/clear');
  },

  methods: {
    fetch() {
      this.$store.dispatch(STORE_PREFIX + 'admin/vacancy/fetchVacancy', this.vacancyId);
    },

    update_vacancy() {
      this.$store
        .dispatch(STORE_PREFIX + 'admin/vacancy/updateVacancy', this.vacancy)
        .then(() => {
          this.$noty.success(this.$tr('vacancy.basic.form.modules.informers.save_success'));
        })
        .catch(err => {
          this.$store.dispatch('global/setError', err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination:first-child {
  padding: 0 0 20px 0;
}

.preferences {
  width: 100%;
  max-width: inherit;
  margin: inherit;
  display: flex;
  flex-direction: row;

  .nav {
    margin-top: 10px;
    width: 200px;
    flex: 0 0 200px;
  }

  .body {
    width: 100%;
  }
}
</style>
